// src/features/itinerary/components/ItineraryDay.jsx
import React from "react";
import Segment from "./Segment";
import { formatDayHeading } from "../utils/itineraryUtils";

export default function ItineraryDay({ day, segments }) {
  return (
    <div className="day-container">
      <div className="tl-section-header">
        <span className="tl-section-title">{formatDayHeading(day)}</span>
      </div>

      <div className="segments-container">
        {segments.map((s, idx) => (
          <Segment
            key={s.id || idx}
            item={s}
            isFirst={idx === 0}
            isLast={idx === segments.length - 1}
          />
        ))}
      </div>
    </div>
  );
}
